import { render } from "./CheckPrizeDialog.vue?vue&type=template&id=4844c8dd&scoped=true&ts=true"
import script from "./CheckPrizeDialog.vue?vue&type=script&lang=ts"
export * from "./CheckPrizeDialog.vue?vue&type=script&lang=ts"

import "./CheckPrizeDialog.scss?vue&type=style&index=0&id=4844c8dd&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4844c8dd"]])

export default __exports__